import { useCallback, useState } from 'react'

export const useEntitySelection = <Entity extends { id: number }>(): [
  Entity[],
  (entity: Entity, state: boolean) => void,
  () => void,
] => {
  const [selectedItems, setSelectedItems] = useState<Entity[]>([])

  const handleChangeSelected = useCallback(
    (item: Entity, isSelected: boolean) => {
      setSelectedItems((prevSelectedItems) => {
        if (isSelected) {
          return [...prevSelectedItems, item]
        }

        return prevSelectedItems.filter(({ id }) => id !== item.id)
      })
    },
    [],
  )

  const resetSelection = useCallback(() => {
    setSelectedItems([])
  }, [])

  return [selectedItems, handleChangeSelected, resetSelection]
}
